import React, { Component } from 'react'
import { Box, Modal } from 'components'
import styled from '@emotion/styled'
import Button from 'components/Button'
import { T, __ } from 'translations/i18n'

interface Props {
  title: string
  subtitle?: string
  isOpen?: boolean
  onConfirm?: () => void
  onClose: () => void
  style?: any
}

export default class ConfirmModal extends Component<Props> {
  render() {
    const { isOpen, onClose, title, onConfirm, subtitle } = this.props
    const btn1 = { flex: 1, minWidth: 'auto', height: 60 }
    const btn2 = { flex: 1, minWidth: 'auto', marginLeft: 15, height: 60 }
    return (
      <Modal visible={isOpen ?? true} onClose={onClose} size="md">
        <Box>
          <Title>{title}</Title>
          <Description>{subtitle}</Description>
        </Box>

        <Box row mt={10}>
          <Button variant="default" title={__(T.misc.cancel)} onClick={onClose} style={btn1} />
          <Button title={__(T.misc.confirm)} onClick={onConfirm} style={btn2} />
        </Box>
      </Modal>
    )
  }
}

const Title = styled.span`
  font-size: 26px;
  font-weight: 700;
  text-align: center;
  margin-top: 10px;
`

const Description = styled.label`
  font-weight: 500;
  padding: 25px 15px;
  font-size: 21px;
  text-align: center;
  opacity: 0.5;
`
